import React, { useCallback, useState } from 'react'
import ModalTerminalButtons from '../../../../../Elements/cart/ModalTerminalButtons'
import ModalChangeCalculator from '../../../../../Elements/changeCalculator'
import ModalTerminalPaymentProcess from '../../../../../Elements/cart/ModalTerminalPaymentProcess'
import ActivateCouponModal from '../../../../../Elements/cart/Coupon/ActivateCouponModal'
import { setRestaurantCouponActivateModal, setRestaurantModalChangeCalculatorIsOpen, setRestaurantModalChangeTipsCalculatorIsOpen, setRestaurantModalInvoiceConfigsIsOpen, setRestaurantModalInvoiceCustomerDataIsOpen, setRestaurantModalTerminalButtonsIsOpen, setRestaurantModalTerminalPaymentProcessIsOpen, setRestaurantPaymentTypeModal, setRestaurantShowDepositPaymentModal } from '../../../../../../redux/action/restaurant'
import { useDispatch, useSelector } from 'react-redux'
import { setCartPaymentSelectedTerminal } from '../../../../../../redux/action/cartPayment'
import InvoiceModals from '../../../../../Elements/cart/InvoiceModals'
import { createCartPaymentInvoiceConfigsThunk } from '../../../../../../redux/thunk/cartPayment'
import { selectDisabledTerminalTips } from '../../../../../../redux/selector/cartPayment'
import { isDisabledTerminalTips } from '../../../../../../redux/selector/cartPayment/helper'
import Tap2PayModals from '../../../../../Elements/cart/Tap2PayModals'
import ModalChangeTipsCalculator from '../../../../../Elements/changeTipsCalculator'
import DepositPaymentModal from '../../../../../Elements/cart/DepositPaymentModal'

const PaymentModals = ({ totalPrice, ecTerminalTips, handleTerminalPayment, handleModalChangePayment, handleModalChangeTipsPayment, paymentMethod, handleInvoicePayment, resetTable, updatePaymentMode, handleTap2PayPayment, handleDepositPayment, showTap2PayAvailabilityCheckerModal, setShowTap2PayAvailabilityCheckerModal }) => {
	const modalTerminalButtonsIsOpen = useSelector(store => store.restaurant.modalTerminalButtonsIsOpen)
	const modalChangeCalculatorIsOpen = useSelector(store => store.restaurant.modalChangeCalculatorIsOpen)
	const modalChangeTipsCalculatorIsOpen = useSelector(store => store.restaurant.modalChangeTipsCalculatorIsOpen)
	const modalTerminalPaymentProcessIsOpen = useSelector(store => store.restaurant.modalTerminalPaymentProcessIsOpen)
	const terminalsLength = useSelector(store => store.cartPayment.terminalsLength)
	const showCouponActivateModal = useSelector(store => store.restaurant.showCouponActivateModal)
	const modalInvoiceConfigsIsOpen = useSelector(store => store.restaurant.modalInvoiceConfigsIsOpen)
	const modalInvoiceCustomerDataIsOpen = useSelector(store => store.restaurant.modalInvoiceCustomerDataIsOpen)
	const showDepositPaymentModal = useSelector(store => store.restaurant.showDepositPaymentModal)
	const disabledTerminalTips = useSelector(selectDisabledTerminalTips('RESTAURANT'))
	const dispatch = useDispatch()
	const [showChangePaymentAmountModal, setShowChangePaymentAmountModal] = useState(false)

	const closeTerminalButtonsModal = useCallback(() => {
		dispatch(setRestaurantModalTerminalButtonsIsOpen(false))
		dispatch(setRestaurantPaymentTypeModal(true))
	}, [dispatch])

	const handleTerminalSelected = useCallback((item) => {
		const disabledTips = isDisabledTerminalTips(item, 'RESTAURANT')
		dispatch(setRestaurantModalTerminalButtonsIsOpen(false))
		if (disabledTips) {
			dispatch(setRestaurantModalTerminalPaymentProcessIsOpen(true))
		} else {
			dispatch(setRestaurantModalChangeCalculatorIsOpen(true))
		}
	}, [dispatch])

	const closeChangeModal = useCallback(() => {
		dispatch(setRestaurantModalChangeCalculatorIsOpen(false))
		dispatch(setCartPaymentSelectedTerminal(null))
		if (paymentMethod === 'EC_TERMINAL' && terminalsLength > 1) {
			dispatch(setRestaurantModalTerminalButtonsIsOpen(true))
		} else {
			dispatch(setRestaurantPaymentTypeModal(true))
		}
	}, [dispatch, paymentMethod, terminalsLength])

	const closeChangeTipsModal = useCallback(() => {
		dispatch(setRestaurantModalChangeTipsCalculatorIsOpen(false))
		dispatch(setRestaurantPaymentTypeModal(true))
	}, [dispatch])

	const reOpenModalChangeCalculator = useCallback(() => {
		dispatch(setRestaurantModalTerminalPaymentProcessIsOpen(false))
		if (disabledTerminalTips) {
			closeChangeModal()
		} else {
			dispatch(setRestaurantModalChangeCalculatorIsOpen(true))
		}
	}, [dispatch, disabledTerminalTips, closeChangeModal])

	const closeModalPaymentsTerminal = useCallback(() => {
		dispatch(setRestaurantModalTerminalPaymentProcessIsOpen(false))
	}, [dispatch])

	const closeActivationModal = useCallback(() => {
		dispatch(setRestaurantCouponActivateModal(false))
	}, [dispatch])

	const closeInvoiceConfigsModal = useCallback(() => {
		dispatch(setRestaurantModalInvoiceConfigsIsOpen(false))
		dispatch(setRestaurantPaymentTypeModal(true))
	}, [dispatch])

	const submitInvoiceConfig = useCallback(async (data) => {
		await dispatch(createCartPaymentInvoiceConfigsThunk(data))
		dispatch(setRestaurantModalInvoiceConfigsIsOpen(false))
		dispatch(setRestaurantModalChangeCalculatorIsOpen(true))
	}, [dispatch])

	const closeInvoiceCustomerDataModal = useCallback(() => {
		dispatch(setRestaurantModalInvoiceCustomerDataIsOpen(false))
		dispatch(setRestaurantPaymentTypeModal(true))
	}, [dispatch])

	const closeChangePaymentAmountModal = useCallback(() => {
		setShowChangePaymentAmountModal(false)
		dispatch(setRestaurantPaymentTypeModal(true))
	}, [dispatch])

	const closeDepositPaymentModal = useCallback(() => {
		dispatch(setRestaurantShowDepositPaymentModal(false))
	}, [dispatch])

	return (
		<>
			<ModalTerminalButtons isOpen={modalTerminalButtonsIsOpen}
														close={closeTerminalButtonsModal}
														totalPrice={totalPrice}
														onTerminalSelected={handleTerminalSelected} />
			<ModalChangeCalculator isOpen={modalChangeCalculatorIsOpen}
														 close={closeChangeModal}
														 totalPrice={totalPrice}
														 isEcTerminal={paymentMethod === 'EC_TERMINAL'}
														 isInvoice={paymentMethod === 'INVOICE'}
														 handlePayment={handleModalChangePayment} />
			<ModalChangeTipsCalculator isOpen={modalChangeTipsCalculatorIsOpen}
																 close={closeChangeTipsModal}
																 totalPrice={totalPrice}
																 handlePayment={handleModalChangeTipsPayment} />
			<ModalTerminalPaymentProcess isOpen={modalTerminalPaymentProcessIsOpen}
																	 totalPrice={totalPrice + ecTerminalTips}
																	 navigateBack={reOpenModalChangeCalculator}
																	 close={closeModalPaymentsTerminal}
																	 handlePayment={handleTerminalPayment}
																	 resetCart={resetTable}
																	 printReceipt={true}
																	 ecTerminalTips={ecTerminalTips}
																	 paymentSource={updatePaymentMode ? 'CASH_REGISTER' : 'RESTAURANT'}
																	 module="RESTAURANT"
																	 orderType="RESTAURANT" />
			<InvoiceModals invoiceConfigsModalIsOpen={modalInvoiceConfigsIsOpen}
										 closeInvoiceConfigsModal={closeInvoiceConfigsModal}
										 submitInvoiceConfig={submitInvoiceConfig}
										 invoiceCustomerDataModalIsOpen={modalInvoiceCustomerDataIsOpen}
										 closeInvoiceCustomerDataModal={closeInvoiceCustomerDataModal}
										 onSubmit={handleInvoicePayment} />
			<Tap2PayModals totalPrice={totalPrice}
										 handlePayment={handleTap2PayPayment}
										 closeChangePaymentAmountModal={closeChangePaymentAmountModal}
										 resetCart={resetTable}
										 module="RESTAURANT"
										 orderType="RESTAURANT"
										 paymentSource={updatePaymentMode ? 'CASH_REGISTER' : 'RESTAURANT'}
										 printReceipt={true}
										 showTap2PayAvailabilityCheckerModal={showTap2PayAvailabilityCheckerModal}
										 setShowTap2PayAvailabilityCheckerModal={setShowTap2PayAvailabilityCheckerModal}
										 setShowChangePaymentAmountModal={setShowChangePaymentAmountModal}
										 showChangePaymentAmountModal={showChangePaymentAmountModal}			/>

			<ActivateCouponModal isOpen={showCouponActivateModal}
													 close={closeActivationModal}
													 isGiftCouponMode={true}
													 giftCouponsType="CART_PAYMENT" />

			<DepositPaymentModal isOpen={showDepositPaymentModal}
													 close={closeDepositPaymentModal}
													 totalPrice={totalPrice}
													 addDeposit={handleDepositPayment} />
		</>
	)
}

PaymentModals.displayName = 'PaymentModals'
export default PaymentModals
